<template>
  <div>
    <v-switch
      :label="$t('incidentReports.deadlyAccident')"
      data-cy="deadly"
      v-model="value.deadly"
    ></v-switch>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data: () => ({}),
  methods: {},
};
</script>
